<template>
	<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 370 370">
		<title>icon-view-details</title>
		<circle class="cls-1" cx="185" cy="185" r="167.5" />
		<line class="cls-2" x1="186.29" y1="102.26" x2="186.29" y2="271.26" />
		<line class="cls-2" x1="270.79" y1="186.76" x2="101.79" y2="186.76" />
	</svg>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';

	@Observer
	@Component({
		components: {}
	})
	export default class ExpandSVG extends Vue {}
</script>

<style scoped>
	.cls-1 {
		fill: #fff;
		stroke-width: 35px;
	}
	.cls-1,
	.cls-2 {
		stroke: #2078ba;
		stroke-miterlimit: 10;
	}
	.cls-2 {
		fill: none;
		stroke-linecap: round;
		stroke-width: 40px;
	}
</style>
